import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
// eslint-disable-next-line import/no-unresolved
import { InteractiveApp, PDFViewer } from 'libs/@cep-miq/deliverable-lib/src';
import BHSCAnalytics from 'libs/@cep-miq/deliverable-lib/src/services/BHSCAnalytics';
import loadAnalytics from 'libs/@cep-miq/deliverable-lib/src/utilities/loadAnalytics';

export function App() {
  const [isUserIdentified, setIsUserIdentified] = useState(false);
  if (!isUserIdentified) {
    loadAnalytics();
    BHSCAnalytics.identifyUser();
    setIsUserIdentified(true);
  }

  return (
    <Router>
      <Switch>
        <Route
          path="/pdf/:encodedUrl"
          render={(props) => <PDFViewer {...props}></PDFViewer>}
        ></Route>
        <Route path="/:id">
          <InteractiveApp />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
